// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"82bbc221","453":"6b759d06","463":"266102af","789":"535c9155"}[chunkId] + ".chunk.js";
};